import type { BelongingsFeatureConfig } from '../../../types/insurances/BelongingsFeatureConfig';

export const belongings: BelongingsFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: true,
            showVariant: true,
            showPackage: false,
            showContractHolder: false,
            fallbackAssistancePhonesKey: 'RO_PERSONAL_BELONGINGS_AND_CARDS',
            fallbackAssistanceEmailsKey: 'RO_PERSONAL_BELONGINGS_AND_CARDS',
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
